import { AtivoMonitoramentoDetalhado } from './ativo-monitoramento-detalhado.model copy';
import { ItemMonitoramentoDetalhado } from './item-monitoramento-detalhado.model';
import { ItemMonitoramento } from './item-monitoramento.model';

export class BancoDadosMonitoramento {

  leitura: ItemMonitoramento;

  public static getAtivo(bancoDados: BancoDadosMonitoramento): AtivoMonitoramentoDetalhado {
    return new AtivoMonitoramentoDetalhado('Banco Dados', [
      new ItemMonitoramentoDetalhado('Leitura', bancoDados.leitura),
    ]);
  }
}
